import { Card, CardContent, CardMedia, Typography, CardHeader } from "@mui/material";
import React, { useState, useEffect } from 'react';
import { properties } from "../utils/properties";


//import logo_aquilone from "../assets/aquilone.jpg";
import logo_aquilone from "../assets/aquilone_2025.jpg";
//import logo_paguro from "../assets/paguro.jpg";
import logo_paguro from "../assets/paguro_2025.jpg";
import logo_agora from "../assets/agora_2025.jpg";
import logo_cincia from "../assets/cincia_2025.jpg";
import logo_drago from "../assets/drago_2025.jpg";

import logo_altro from "../assets/eduteca.jpg";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import DashboardDailyView from "./DashboardDailyView";
import DashboardWeeklyView from "./DashboardWeeklyView";
import DashboardMonthlyView from "./DashboardMonthlyView";

import DashboardDailyView_2 from "./DashboardDailyView_2";
import DashboardDailyView_3 from "./DashboardDailyView_3";
import DashboardDailyView_4 from "./DashboardDailyView_4";
import DashboardDailyView_5 from "./DashboardDailyView_5";
import DashboardDailyView_6 from "./DashboardDailyView_6";

import DashboardWeeklyView_2 from "./DashboardWeeklyView_2";
import DashboardWeeklyView_3 from "./DashboardWeeklyView_3";
import DashboardWeeklyView_4 from "./DashboardWeeklyView_4";
import DashboardWeeklyView_5 from "./DashboardWeeklyView_5";
import DashboardWeeklyView_6 from "./DashboardWeeklyView_6";

import DashboardMonthlyView_2 from "./DashboardMonthlyView_2";
import DashboardMonthlyView_3 from "./DashboardMonthlyView_3";
import DashboardMonthlyView_4 from "./DashboardMonthlyView_4";
import DashboardMonthlyView_5 from "./DashboardMonthlyView_5";
import DashboardMonthlyView_6 from "./DashboardMonthlyView_6";

import LogoStepper from "./LogoStepper"; 
import Select from 'react-select';
import { useGetOne,useGetList, useGetMany,useGetManyReference } from 'react-admin';
import { SurveyQuestionMatrixDropdownBase } from "survey-react-ui";

const images = [logo_aquilone,logo_paguro,logo_drago, logo_agora, logo_cincia];
//const idEnti=["48","50"]


function getName() {
  let result = 'Benvenuto ';
  result=result+localStorage.getItem("username")  
  //let result = 'Benvenuto Admin';
  return result;
}

/*
const generateImageWithText = (imageSrc, text) => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.src = imageSrc;

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      
      ctx.font = "40px Arial";
      ctx.fillStyle = "black"; 
      ctx.fillText(text, 200, 220); 

      resolve(canvas.toDataURL()); 
    };
  });
};
*/


export const Dashboard = () => {

  const [idEnti, setIdEnti]= useState([]);
  const [images, setImages]=useState([]);

  const { data, total, isPending, error } = useGetList(
    'enti',
    { 
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'id', order: 'ASC' }
    }
  );
  const [activeStep, setActiveStep] = useState(0);
  const [tabValue, setTabValue] = React.useState(0);
  const [ente, setEnte] = React.useState(0);

  const [selectedAmbito, setSelectedAmbito]=React.useState(0);
  //const [defaultAmbito, setDefaultAmbito]=React.useState(0);
  const [ambiti, setAmbiti]=React.useState([]);

  const handleNext = () => {    
    //console.log("PEE", idEnti, images, ente, (ente + 1) % idEnti.length)
    //initAmbito();
    setEnte((prevIndex) => (prevIndex + 1) % idEnti.length);
    setActiveStep((prevStep) => (prevStep + 1) % images.length);
    
  };
  
  const handlePrev = () => {
    //initAmbito();
    setEnte((prevIndex) => (prevIndex - 1 + idEnti.length) % idEnti.length);
    setActiveStep((prevStep) => (prevStep - 1 + images.length) % images.length);    
    
  };

  
  const handleChange = (event, newValue) => {
    console.log("HC",event, newValue);
    setTabValue(newValue);
  };

  /*useEffect(() => {
    console.log("UE",ente);        
  }, [ente]);*/

  const initAmbito = () => {
  //  function initAmbito() {
    console.log("initambito");
    //se volessi che cambiando ente ripartisse dal valore di defualt è sufficiente eliminare la condizione selectedAmbtio==0
    //if(localStorage.getItem("ambiti") !== null){
      if(localStorage.getItem("ambiti") !== null &&selectedAmbito==0){
      //const arr = localStorage.getItem("ambiti").split(",").map(Number);
      const arr = localStorage.getItem("ambiti").split(",");
      setAmbiti(arr);
      console.log("AAAAAAAAAAAAAARR",arr);
      /*if(localStorage.getItem("ambiti").includes("6"))
        setDefaultAmbito("6");
      if(localStorage.getItem("ambiti").includes("5"))
        setDefaultAmbito("5");
      if(localStorage.getItem("ambiti").includes("4"))
        setDefaultAmbito("4");  
      if(localStorage.getItem("ambiti").includes("3"))
        setDefaultAmbito("3");  
      if(localStorage.getItem("ambiti").includes("2"))
        setDefaultAmbito("2");  
      if(localStorage.getItem("ambiti").includes("1"))
        setDefaultAmbito("1");  
        */
      if(localStorage.getItem("ambiti").includes("6")){
        const val={value: "6", label:"Ludoteche 10/14"};
        setSelectedAmbito(val);
        //setSelectedAmbito("6");
      }

      if(localStorage.getItem("ambiti").includes("5")){
        //setSelectedAmbito("5");
        const val={value: "5", label:"Ludoteche 6/10"};
        setSelectedAmbito(val);
      }
        
      if(localStorage.getItem("ambiti").includes("4")){
        //setSelectedAmbito("4");
        const val={value: "4", label:"Ludoteche 3/6"};
        setSelectedAmbito(val);
      }
          
      if(localStorage.getItem("ambiti").includes("3")){
        //setSelectedAmbito("3");  
        const val= {value: "3", label:"Ludoteche 0/3"};
        setSelectedAmbito(val);
      }
        
      if(localStorage.getItem("ambiti").includes("2")){
        //setSelectedAmbito("2");  
        const val={value: "2", label:"Centro Bambini-Famiglie"};
        setSelectedAmbito(val);
      }
        
      if(localStorage.getItem("ambiti").includes("1")){
        //setSelectedAmbito("1");
        const val={value: "1", label:"Spazio Gioco"};
        setSelectedAmbito(val);
      }
             
    }    

  };

  useEffect(() => {
    console.log("DATA",data);    
    initAmbito();
   
    if(data){
      //data.sort((a, b) => Number(a.id) - Number(b.id));
      let intImages=[];
      let intIds=[];
      for (let i = 0; i < data.length; i++) {  
        //console.log("TESET",data);
        //if (data[i].id =="50") {  //PAGURO
        if (data[i].nome =="Paguro") {  //PAGURO
          intIds.push(data[i].id);
          intImages.push(logo_paguro);          
        } 
        //else if (data[i].id =="48") {  //aquilone
        else if (data[i].nome=="Aquilone") {  //aquilone
          intIds.push(data[i].id);
          intImages.push(logo_aquilone);
        }
        else if (data[i].nome=="Agorà") {  //agorà
          intIds.push(data[i].id);
          intImages.push(logo_agora);
        }
        else if (data[i].nome=="Drago Volante") {  //drago
          intIds.push(data[i].id);
          intImages.push(logo_drago);
        }
        else if (data[i].nome=="Cinciallegra") {  //cincia
          intIds.push(data[i].id);
          intImages.push(logo_cincia);
        }
        else if (data[i].id !="1") {  //altri enti
          intIds.push(data[i].id);
          intImages.push(logo_altro);

          //let logo= generateImageWithText(logo_altro, data[i].nome).then((logo) => {
          //  console.log("POS",i);
          //  intImages[i]=logo;
            //intImages.push(logo);
          //});
          
          //intImages.push(logo_altro);
        }
      }
      setImages(intImages);
      setIdEnti(intIds);
    }
  }, [data,ente]);


  function convertIdToAmbito(idi) {    
    if ((idi != undefined) && (idi != 0)){            
      if(idi=="6")
        return "Ludoteche 10/14";        
      else if(idi=="5")
        return "Ludoteche 6/10";        
      else if(idi=="4")
        return "Ludoteche 3/6";        
      else if(idi=="3")
        return "Ludoteche 0/3";        
      else if(idi=="2")
        return "Centro Bambini-Famiglie";        
      else if(idi=="1")
        return "Spazio Gioco";        
      else
        return "Non Valorizzato";        
    }
}
const ambitiValues =[ 
  {value: "1", label:"Spazio Gioco"},
  {value: "2", label:"Centro Bambini-Famiglie"},
  {value: "3", label:"Ludoteche 0/3"},
  {value: "4", label:"Ludoteche 3/6"},
  {value: "5", label:"Ludoteche 6/10"},
  {value: "6", label:"Ludoteche 10/14"},
  ];

  function handleChange1(event, ente) {
    if (event && event.value){     
       console.log("EV",event);        
       console.log("ENTE",ente);
       setSelectedAmbito(event);
     }
     //doPost(id, "SettoreCodice", event.value);    
   }
 

  return (    
    <Card  sx={{ width: "100%", overflowX: "hidden" }}>
    <CardHeader title={getName()} style={{textAlign:"left"}}/>
    <LogoStepper images={images}    
        activeStep={activeStep}
        handleNext={handleNext}
        handlePrev={handlePrev} />

    
    {selectedAmbito != 0 ? ( 
      
        <div style={{  display: "flex", paddingTop:"10px", paddingRight:"20px", width: "100%"}}> 
          
          <Typography sx={{paddingLeft:"20px", paddingTop:"7px", color:"#333333",  mb: 1.5, paddingRight:"10px" }} component={'div'}> Ambito: 
          </Typography>
          <div style={{ width: "100%"}}>
          <Select   optionHeight={31}
              
              value={selectedAmbito}
              sx={{width:"100%"}}
              styles={{
                menu: (base) => ({ ...base, zIndex: 9999, position: 'absolute' }),
                option: (base) => ({ ...base, textAlign: 'left' }),
                singleValue: (base) => ({...base, textAlign: 'left', width: '100%'})
              }}
              onChange={(event) => handleChange1(event, ente)}
              //options={ambitiValues}                                                                                           
              options={ambitiValues.filter(item => ambiti.includes(item.value))}
              /*theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          primary25: '#a2ee7d',
                          primary: 'black',
                        },
                        })} */
            />    
            </div>
        </div> 
        ): (<></>)}
         
         {selectedAmbito.value == 1 &&  ( 

              <CardContent  sx={{ width:"100%", overflowX: "hidden"}} >        
                  <Box sx={{ borderBottom: 1, borderColor: 'divider',overflowX: "auto" }}>
                      <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                          <Tab label="Giornaliera" />
                          <Tab label="Settimanale"  />
                          <Tab label="Mensile"  />
                      </Tabs>
                  </Box>          
                  {tabValue === 0 &&
                    <div style={{ width: "100%", overflowX: "hidden" }}>
                      <DashboardDailyView enteId={idEnti[ente]}/>     
                    </div>
                  }
                    {tabValue === 1 &&
                    <DashboardWeeklyView enteId={idEnti[ente]}/>     
                  }
                  {tabValue === 2 &&
                    <DashboardMonthlyView enteId={idEnti[ente]}/>     
                  }
                
                <Typography variant="body1" color="text.secondary">          
                      ZeroSei Versione {properties.version}
                </Typography>
              </CardContent>    
          )}
          {selectedAmbito.value == 2 &&  ( 
              <CardContent  sx={{ width:"100%", overflowX: "hidden"}} >        
              <Box sx={{ borderBottom: 1, borderColor: 'divider',overflowX: "auto" }}>
                  <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Giornaliera" />
                      <Tab label="Settimanale"  />
                      <Tab label="Mensile"  />
                  </Tabs>
              </Box>          
              {tabValue === 0 &&
                <div style={{ width: "100%", overflowX: "hidden" }}>
                  <DashboardDailyView_2 enteId={idEnti[ente]}/>     
                </div>
              }
                {tabValue === 1 &&
                <DashboardWeeklyView_2 enteId={idEnti[ente]}/>     
              }
              {tabValue === 2 &&
                <DashboardMonthlyView_2 enteId={idEnti[ente]}/>     
              }
            
            <Typography variant="body1" color="text.secondary">          
                  ZeroSei Versione {properties.version}
            </Typography>
          </CardContent>    

          )}
             {selectedAmbito.value == 3 &&  ( 
              <CardContent  sx={{ width:"100%", overflowX: "hidden"}} >        
              <Box sx={{ borderBottom: 1, borderColor: 'divider',overflowX: "auto" }}>
                  <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Giornaliera" />
                      <Tab label="Settimanale"  />
                      <Tab label="Mensile"  />
                  </Tabs>
              </Box>          
              {tabValue === 0 &&
                <div style={{ width: "100%", overflowX: "hidden" }}>
                  <DashboardDailyView_3 enteId={idEnti[ente]}/>     
                </div>
              }
                {tabValue === 1 &&
                <DashboardWeeklyView_3 enteId={idEnti[ente]}/>     
              }
              {tabValue === 2 &&
                <DashboardMonthlyView_3 enteId={idEnti[ente]}/>     
              }
            
            <Typography variant="body1" color="text.secondary">          
                  ZeroSei Versione {properties.version}
            </Typography>
          </CardContent>    

          )}
             {selectedAmbito.value == 4 &&  ( 
              <CardContent  sx={{ width:"100%", overflowX: "hidden"}} >        
              <Box sx={{ borderBottom: 1, borderColor: 'divider',overflowX: "auto" }}>
                  <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Giornaliera" />
                      <Tab label="Settimanale"  />
                      <Tab label="Mensile"  />
                  </Tabs>
              </Box>          
              {tabValue === 0 &&
                <div style={{ width: "100%", overflowX: "hidden" }}>
                  <DashboardDailyView_4 enteId={idEnti[ente]}/>     
                </div>
              }
                {tabValue === 1 &&
                <DashboardWeeklyView_4 enteId={idEnti[ente]}/>     
              }
              {tabValue === 2 &&
                <DashboardMonthlyView_4 enteId={idEnti[ente]}/>     
              }
            
            <Typography variant="body1" color="text.secondary">          
                  ZeroSei Versione {properties.version}
            </Typography>
          </CardContent>    

          )}
             {selectedAmbito.value == 5 &&  ( 
              <CardContent  sx={{ width:"100%", overflowX: "hidden"}} >        
              <Box sx={{ borderBottom: 1, borderColor: 'divider',overflowX: "auto" }}>
                  <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Giornaliera" />
                      <Tab label="Settimanale"  />
                      <Tab label="Mensile"  />
                  </Tabs>
              </Box>          
              {tabValue === 0 &&
                <div style={{ width: "100%", overflowX: "hidden" }}>
                  <DashboardDailyView_5 enteId={idEnti[ente]}/>     
                </div>
              }
                {tabValue === 1 &&
                <DashboardWeeklyView_5 enteId={idEnti[ente]}/>     
              }
              {tabValue === 2 &&
                <DashboardMonthlyView_5 enteId={idEnti[ente]}/>     
              }
            
            <Typography variant="body1" color="text.secondary">          
                  ZeroSei Versione {properties.version}
            </Typography>
          </CardContent>    

          )}
             {selectedAmbito.value == 6 &&  ( 
              <CardContent  sx={{ width:"100%", overflowX: "hidden"}} >        
              <Box sx={{ borderBottom: 1, borderColor: 'divider',overflowX: "auto" }}>
                  <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Giornaliera" />
                      <Tab label="Settimanale"  />
                      <Tab label="Mensile"  />
                  </Tabs>
              </Box>          
              {tabValue === 0 &&
                <div style={{ width: "100%", overflowX: "hidden" }}>
                  <DashboardDailyView_6 enteId={idEnti[ente]}/>     
                </div>
              }
                {tabValue === 1 &&
                <DashboardWeeklyView_6 enteId={idEnti[ente]}/>     
              }
              {tabValue === 2 &&
                <DashboardMonthlyView_6 enteId={idEnti[ente]}/>     
              }
            
            <Typography variant="body1" color="text.secondary">          
                  ZeroSei Versione {properties.version}
            </Typography>
          </CardContent>    

          )}
  </Card>
      );  


};